module.exports = __webpack_public_path__ + "img/t_5.96f80ec8.png";